import * as _ from "lodash";
import * as $ from "jquery";
import * as Backbone from "backbone";
import { BaseAccountListView, BaseAccountViewOptions } from "../_BaseAccountViews";
import { InstallCollection } from "../../../collections/Installs";

const crypto = require('crypto');

export class MapsAccountView extends BaseAccountListView {

    private currentOrg = null;
    private publicMapsEnabled = false;
    protected mapViewTemplate = _.template(require('templates/account/mapview/mapView.html'));
    private orgInstallCollection = new InstallCollection(this.options.installCollection.filter((i) => {
        return Number(i.get('organization_id')) === this.options.currentOrganizationId && !i.isVirtual();
    }));

    constructor(options: BaseAccountViewOptions) {
        super(<any>_.extend({}, options, {
            tagName: 'div',
            events: {
                'change .mv-enable_toggle': 'handleEnableMaps',
                'change .mv-oaq_enable_toggle': 'handleOAQToggle',
                'click .mv-slug_edit-btn': 'handleEditSlug',
                'click .mv-slug_save-btn': 'handleSaveSlug',
                'click .mv-slug_cancel-btn': 'handleCancelEditSlug',
            }
        }));
    }

    show() {
        this.collectionLoaded = true;
        this.render();
    }

    render() {
        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            currentOrganizationId: this.options.currentOrganizationId,
            collectionLoaded: this.collectionLoaded,
            urlAddon: '/mapview'
        }));

        // Get installs with no address
        const noCoordintaesInstalls = this.orgInstallCollection.filter((install) => {
            return !install.get('property_geo_latitude') || !install.get('property_geo_longitude');
        });

        // Check if the maps app is enabled and get the current slug
        this.currentOrg = this.options.organizationCollection.find(org => org.get('id') === this.options.currentOrganizationId);
        this.publicMapsEnabled = this.currentOrg.get('enable_public_maps');
        const slug = this.currentOrg.get('public_maps_slug');
        const showOAQ = this.currentOrg.get('show_oaq_public_maps');

        // Use org's name to provide example slug
        const slugPlaceholder = this.currentOrg.get('name').
            replace(/\s+/g, '-').
            toLowerCase();

        // If there is no slug, generate a random number to use instead
        // if (!slug) {
        //     slug = crypto.randomBytes(4).toString("hex");
        // }

        this.$('.container').append(this.mapViewTemplate({
            enabled: this.publicMapsEnabled,
            showOAQ: showOAQ,
            slugValue: slug,
            slugPlaceholder: slugPlaceholder,
            noCoordintaesInstalls: noCoordintaesInstalls,
            baseInstallUrl: `#/settings/install/${this.options.currentOrganizationId}`
        }));

        (<any>this.$('input[type="checkbox"]')).bootstrapToggle();
        this.showBreadcrumbs();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        super.showBreadcrumbs('Map View', 'Categories');
    }

    handleEnableMaps(e: JQuery.UIEventBase) {
        this.publicMapsEnabled = $(e.currentTarget).is(':checked');
        // Hide/show map settings
        this.$(".mv-settings").toggleClass('hidden', !this.publicMapsEnabled);
        this.toggleEditSlug(true);

        //If they disable, we should save the settings
        if (!this.publicMapsEnabled) {
            const slug = this.currentOrg.get('public_maps_slug');
            this.saveMapsSettings(slug);
        }
    }

    handleOAQToggle(e: JQuery.UIEventBase) {
        // Save the OAQ toggle state immediately when changed
        const slug = this.currentOrg.get('public_maps_slug');
        this.saveMapsSettings(slug);
    }

    handleEditSlug(e: JQuery.UIEventBase) {
        e.preventDefault();
        this.toggleEditSlug(true);
    }

    handleSaveSlug(e: JQuery.UIEventBase) {
        e.preventDefault();

        //Slug cannot be empty
        const slugRaw = String(this.$('.mv-slug_input').val());
        if (slugRaw.length === 0) {
            this.notifyUser('Missing Slug', 'Please enter a valid slug value before saving.', 'warning');
            return;
        }

        // Convert the input string into a valid slug
        const slug = this.slugify(slugRaw);
        //Save settings
        this.saveMapsSettings(slug);
    }

    slugify(string) {
        return string
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-") //spaces to dashes
            .replace(/&/g, '-and-') //ampersand to and
            .replace(/[^\w\-]+/g, "") //remove non-words
            .replace(/\-\-+/g, "-") //collapse multiple dashes
            .replace(/^-+/, "") //trim starting dash
            .replace(/-+$/, ""); //trim ending dash
    }

    handleCancelEditSlug(e: JQuery.UIEventBase) {
        e.preventDefault();
        //Slug cannot be empty
        const slugRaw = String(this.$('.mv-slug_input').val());
        if (slugRaw.length === 0) {
            this.notifyUser('Missing Slug', 'Please enter a valid slug value before continuing.', 'warning');
            return;
        }
        this.toggleEditSlug(false);
    }

    toggleEditSlug(isEdit: boolean) {
        //Hide cancel edit button on first time edit
        const slugRaw = String(this.$('.mv-slug_input').val());
        if (isEdit && slugRaw.length === 0) {
            $('.mv-slug_cancel-btn').prop("hidden", true);
        } else {
            $('.mv-slug_cancel-btn').prop("hidden", false);
        }

        //Toggle edit visibility
        $('.mv-slug').prop("hidden", isEdit);
        $('.mv-slug_edit').prop("hidden", !isEdit);
    }

    saveMapsSettings(slug: string) {
        this.publicMapsEnabled = this.$('.mv-enable input').is(':checked');
        const showOAQ = this.$('.mv-oaq_enable input').is(':checked');

        //Check that the slug is not empty when the maps are enabled
        if (this.publicMapsEnabled && slug === '') {
            this.notifyUser('Missing Slug', 'Please enter a valid slug value before saving.', 'warning');
            return;
        }

        $.ajax({
            type: "PUT",
            url: `${this.options.organizationCollection.url()}/${this.options.currentOrganizationId}`,
            data: JSON.stringify({
                name: this.currentOrg.get('name'),
                sso_email_domain: this.currentOrg.get('sso_email_domain'),
                sso_idp: this.currentOrg.get('sso_idp'),
                sso_idp_type: this.currentOrg.get('sso_idp_type'),
                enable_public_maps: this.publicMapsEnabled,
                public_maps_slug: slug,
                show_oaq_public_maps: showOAQ,
                apps: this.getOrgEnabledApps(),
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                // Set slug values
                $('.mv-slug_value a')
                    .text(`https://maps.attuneiot.com/${slug}`)
                    .attr("href", `https://maps.attuneiot.com/${slug}`);;
                $('.mv-slug_input').val(slug);
                this.toggleEditSlug(false);
                this.notifyUser('Maps settings saved succesfully.', '', 'success');
                this.refetchCollectionsAndShow(this.options.currentOrganizationId, 'mapview');
            },
            error: (err) => {
                this.setFormError(err);
            }
        });
    }

    // Get enabled apps for Organization
    getOrgEnabledApps() {
        const enabledApps = [];
        this.options.appCollection.forEach(app => {
            if (app.get('organization_id') === this.currentOrg.get('id') && app.get('enabled')) {
                enabledApps.push(app.get('app_type_id'));
            }
        });

        return enabledApps;
    }

    notifyUser(title?, message?, type?) {
        (<any>$).notify({
            title: title,
            message: message,
            icon: type === 'success' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle',
        }, {
            animate: {
                enter: 'animated fadeInUp',
            },
            // The type property defines the css style
            // See alerts.less for available styles
            type: `${type}-alt`,
            placement: { from: "bottom", align: "center" }
        });
    }

    setFormError(err) {
        if (err.responseJSON != null && err.responseJSON.code == 'INVALID SLUG') {
            var title = err.responseJSON.message;
            this.notifyUser(title, "Please select another slug to continue.", "warning");
        } else {
            // Show default error message
            this.notifyUser("Could not save", "", "danger");
        }
    }

    refetchCollectionsAndShow(orgID, view) {
        $.when(this.options.organizationCollection.fetch()).done(() => {
            // Backbone.history.loadUrl();
            window.location.hash = "#/account/" + orgID + '/' + view;

            window['App'].Bus.trigger('navigation:update');
        });
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/account/maps/MapsAccountView.ts